export const ATTENDEES_ROLES = {
  MAIN: 'MAIN',
  OTHER_ADULT: 'OTHER_ADULT',
  KID: 'KID',
};

const getAttendeeValidationSchema =
  (role: string) =>
  ({ validationSchema }: AppState) => {
    if (Object(ATTENDEES_ROLES).hasOwnProperty(role)) {
      return validationSchema[role];
    }

    throw new Error('USER ROLE DOES NOT EXIST');
  };

const getAttendeeValidationSchemaByRole = (isMain: boolean, isChild: boolean) => {
  let role = ATTENDEES_ROLES.OTHER_ADULT;

  if (isChild) {
    role = ATTENDEES_ROLES.KID;
  } else if (isMain) {
    role = ATTENDEES_ROLES.MAIN;
  }

  return getAttendeeValidationSchema(role);
};

const getAddressValidationSchema = ({ validationSchema }: AppState) => validationSchema.address;

const getAttendeesValidationSchema = ({ validationSchema }: AppState) => {
  const schemaByType = {};

  for (const [key, schema] of Object.entries(validationSchema)) {
    if (Object(ATTENDEES_ROLES).hasOwnProperty(key)) {
      schemaByType[key] = schema;
    }
  }

  return schemaByType;
};

export {
  getAttendeeValidationSchema,
  getAttendeeValidationSchemaByRole,
  getAddressValidationSchema,
  getAttendeesValidationSchema,
};
